export default "__VITE_ASSET__Blk1b$Ul__"